import React, { Component } from "react";
import { Card } from "components/Card/Card.jsx";
import {
  Row,
  Col,
  FormControl,
  ControlLabel,
} from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from 'moment';

export class RuleCard extends Component {

	deleteRuleEntry = (ruleIndex) => {
		const updatedRules = [...this.props.rules];
		updatedRules.splice(ruleIndex, 1);
		this.props.onUpdateRules(updatedRules);
	}

	handleDateChange = (date, ruleIndex, key) => {
    let value = moment(date).format("YYYY-MM-DD");
		const updatedRules = [...this.props.rules];
		updatedRules[ruleIndex] = {
			...updatedRules[ruleIndex],
			[key]: value
		}
		this.props.onUpdateRules(updatedRules);

  };

	onChangeAttendanceRule = (ruleIndex, event) => {
		const { value } = event.target;
		const rule = this.props.ruleOptions.find(opt => opt.value === value);
		const updatedRules = [...this.props.rules];
		updatedRules[ruleIndex] = {
			...updatedRules[ruleIndex],
			rule: rule.data
		}
		this.props.onUpdateRules(updatedRules);
	}

  render() {

		const { rules, ruleOptions=[] } = this.props;
    return (
			<div>
				{rules.map((rule, ruleIndex) => {
					return <Card
						hideFooter
						key={ruleIndex}
						title={`Rule ${ruleIndex + 1}`}
						content={
							<Row>
								<Col sm={4}>
									<ControlLabel>Rule</ControlLabel>
									<FormControl
										componentClass="select" 
										onChange={(event) => this.onChangeAttendanceRule(ruleIndex, event)}
										value={rule.rule._id}
									>
										<option value="">Select</option>
										{
											ruleOptions.map((option, index) => {
												return <option key={index} value={option.value}>{option.label}</option>
											})
										}
									</FormControl>
								</Col>
								<Col sm={4}>
									<ControlLabel>Effective Start Date</ControlLabel>
									<DatePicker
										selected={rule.effectiveDateStart ? moment(rule.effectiveDateStart, 'YYYY-MM-DD').toDate() : ''}
										onChange={(date) => this.handleDateChange(date, ruleIndex, 'effectiveDateStart')}
										dateFormat="yyyy-MM-dd"
										className="dateInput"
										dropdownMode="select"
										showYearDropdown
										timeFormat={false}
									/>
								</Col>
								<Col sm={4}>
									<ControlLabel>Effective End Date</ControlLabel>
									<div className="rule-actions">
										<DatePicker
											selected={rule.effectiveDateEnd ? moment(rule.effectiveDateEnd, 'YYYY-MM-DD').toDate() : ''}
											onChange={(date) => this.handleDateChange(date, ruleIndex, 'effectiveDateEnd')}
											dateFormat="yyyy-MM-dd"
											className="dateInput"
											dropdownMode="select"
											showYearDropdown
										/>
										{ruleIndex !== 0 ? <i className="pe-7s-trash" onClick={() => this.deleteRuleEntry(ruleIndex)} /> : null}
									</div>
								</Col>
							</Row>
						}
					/>
				})}
			</div>
		);
	}
}

export default RuleCard;
